<script setup lang="ts">
import { useScriptTag } from '@vueuse/core'

const WIDGET_URL = 'https://widget-copilot.vercel.app/pongo-copilot-widget.js'
const WIDGET_TAG = 'pongo-copilot-widget'
const EXCLUDED_ROUTES = ['Home', 'Import']

const { jwt, isSupportConnection } = useLocalStorage()
const route = useRoute()

const isAllowedRoute = computed(
  () => route.meta.requiresAuth === true && !EXCLUDED_ROUTES.includes(route.name as string)
)
const currentPage = computed(() => route.path.replace(/^\//, ''))

const isDefined = ref(false)

const { load } = useScriptTag(WIDGET_URL, () => {}, { manual: true, type: 'module' })

customElements.whenDefined(WIDGET_TAG).then(() => (isDefined.value = true))
load().catch(() => undefined)
</script>

<template>
  <pongo-copilot-widget
    v-if="isAllowedRoute && isDefined"
    :token="jwt"
    :page="currentPage"
    :support-connection="isSupportConnection"
    position="bottom-right"
  />
</template>
